export default {
      id: "logo-iedn-usage",
      viewBox: "0 0 101 27",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#logo-iedn",
      toString: function () {
        return this.url;
      }
    }